<template>
  <page-template page-id="MmeLogin" ref="super">

    <document-title :title="$tb('pages.loginMme.documentTitle')"></document-title>

    <template v-slot:before v-if="isTitlebarActive">
      <titlebar :text="$tb('pages.loginMme.header', {0: $store.state.appName})"></titlebar>
    </template>

    <div class="ui column">

      <brand-header :text="$t('pages.loginMme.title')"
                    :has-extension="hasHeaderExtension"
                    :has-logo="hasBrandLogo">
      </brand-header>

      <messages id="Notifications" ref="postman" error-element-id="server-errors" aria-role="none"></messages>
      <div class="ui custom-ui segment">
        <p style="font-weight: bold" v-html="showMmeMessage" :data-auth-state="authState" id="mmeMessage"></p>
        <mme-loader :active="showSpinner" :message="$tb('pages.loginMme.pending')" ></mme-loader>
      </div>

      <div class="field" v-if="showLoginMmeBackButton">
        <button id="back" @click="goToLogin" class="ui fluid basic button">
          {{$t('common.button.back')}}
        </button>
      </div>

    </div>

  </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import BrandHeader from '../components/BrandHeader.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'
import MmeLoader from '../components/MmeLoader.vue'
import { MME_POLLINTERVAL, MME_POLLTIMEOUT } from '../js/constants.js'

/* global contextPath */
export default {
  components: {
    PageTemplate,
    Titlebar,
    BrandHeader,
    MmeLoader
  },
  mixins: [mixin, brand, MME_POLLINTERVAL],
  props: {
    mmeAuthRequest: {
      mmeAuthRequest: String,
      requestId: String
    }
  },
  data: function () {
    return {
      uid: this.$store.state.uid,
      requestId: this.$store.state.requestId,
      username: this.$store.state.username,
      pollInterval: MME_POLLINTERVAL,
      pollTimeout: MME_POLLTIMEOUT,
      polling: null,
      authState: 'invalid'
    }
  },
  computed: {
    showMmeMessage: function () {
      const v = this
      if (v.authState === 'PENDING') {
        return v.$tb('pages.loginMme.subheader', { 0: this.username })
      } else if (v.authState === 'APPROVED') {
        return v.$tb('pages.loginMme.approved')
      } else if (v.authState === 'DENIED') {
        return v.$tb('pages.loginMme.denied')
      } else if (v.authState === 'EXPIRED') {
        return v.$tb('pages.loginMme.expired')
      }
      return v.$tb('pages.loginMme.invalid')
    },
    showSpinner: function () {
      return this.authState === 'PENDING'
    }
  },
  methods: {
    goToLogin: function () {
      this.$router.push('/')
    },
    init: function () {
      if (this.mmeAuthRequest && this.mmeAuthRequest.authState) {
        this.authState = this.mmeAuthRequest.authState
      }
      console.log('polling auth state of the user' + this.uid + 'for the request' + this.requestId + ', state=' + this.auth + ' - ' + this.authState)
      this.polling = setInterval(() => this.getUserAuthState(), this.pollInterval)
      setTimeout(this.onTimeout, this.pollTimeout)
    },

    getUserAuthState: async function () {
      if (this.mmeAuthRequest && this.mmeAuthRequest.uid && this.mmeAuthRequest.requestId) {
        const payload = this.$api.payloads.buildGetAuthStatePayload(this.mmeAuthRequest.uid, this.mmeAuthRequest.requestId)
        $.ajax({
          url: contextPath + '/login/mme/status',
          method: 'POST',
          data: payload,
          contentType: 'application/json',
          dataType: 'json'
        }).done(this.handleResponse)
          .fail(this.onFail)
      }
    },

    onFail: function (response) {
      this.onAjaxError(response)
      this.$refs.super.stopLoading()
      // this.authState = 'ERROR' // If there is error, shall polling continue as retry?
      // clearInterval(this.polling)
    },
    onTimeout: function () {
      this.authState = 'EXPIRED'
      clearInterval(this.polling)
    },
    handleResponse: function (response) {
      if (response && response[0] && response[0].authState) {
        this.authState = response[0].authState
        console.log('this.authState=' + this.authState)
        if (this.authState === 'APPROVED') {
          clearInterval(this.polling)
          const payload = this.$api.payloads.buildMmePayload(this.mmeAuthRequest.uid, this.mmeAuthRequest.requestId)
          this.$api.login.authenticateWithMme(payload, this.handleRoutingResponse, this.onFail)
          return
        }

        if (this.authState === 'DENIED') {
          clearInterval(this.polling)
          const payload = this.$api.payloads.buildMmePayload(this.mmeAuthRequest.uid, this.mmeAuthRequest.requestId)
          this.$api.login.authenticateWithMme(payload, this.handleRoutingResponse, this.onFail)
          return
        }
      }

      this.auth = ''
    }
  },
  mounted: function () {
    console.log(`MFA login initiated for uid [uid=${this.uid}]`)
    this.init()
    // if back button is pressed
    window.onpopstate = function () {
      clearInterval(this.polling)
    }
  },
  beforeDestroy: function () {
    console.log('polling is cleared')
    clearInterval(this.polling)
  },
  watch: {
    $v: {
      handler () {
        this.handleResponse()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .denied {
    color: red;
  }
</style>
